"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sprite = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useImages_1 = require("../useImages");
require("./Sprite.scss");
const numberFormatter_1 = require("../numberFormatter");
function Sprite({ name: spriteName, amount }) {
    let name = spriteName;
    if (spriteName.startsWith("research-")) {
        name = "research";
    }
    else if (spriteName.startsWith("boost-")) {
        name = "boost";
    }
    else if (spriteName.startsWith('redeem-mc--')) {
        name = spriteName.replace('redeem-mc--', '');
    }
    const spriteContents = (0, useImages_1.useImages)()[name];
    const alt = spriteContents ? name : undefined;
    const image = (0, jsx_runtime_1.jsx)("img", { alt: alt, className: "sprite", src: spriteContents });
    if (amount !== undefined) {
        amount = (0, numberFormatter_1.parseFormat)(amount);
        return (0, jsx_runtime_1.jsxs)("span", { children: [(0, numberFormatter_1.formatNumber)(amount), image] });
    }
    return image;
}
exports.Sprite = Sprite;
